import { render } from "./ComponentSelection.vue?vue&type=template&id=0e0f53d8&scoped=true"
import script from "./ComponentSelection.vue?vue&type=script&lang=js"
export * from "./ComponentSelection.vue?vue&type=script&lang=js"

import "./ComponentSelection.vue?vue&type=style&index=0&id=0e0f53d8&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e0f53d8"]])

export default __exports__